import { createFileRoute, redirect } from '@tanstack/react-router'
import { allDocs } from 'content-collections'

const MDX_EXT_REGEX = /\.(md|mdx)$/

export const Route = createFileRoute('/(public)/(main-layout)/helpcenter/')({
  loader: () => {
    // Get the intro doc or redirect to first doc
    const introDoc = allDocs.find((doc) => doc._meta.path === 'intro') || allDocs[0]
    if (introDoc) {
      const slug = introDoc._meta.path.replace(MDX_EXT_REGEX, '')
      throw redirect({ to: `/helpcenter/${slug}` })
    }
    throw redirect({ to: '/helpcenter/intro' })
  },
})
